import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { localizationFeatureKey } from './selectors';
import { featureReducer } from './reducer';
import { FeatureEffects } from './effects';

@NgModule({
  imports: [
    StoreModule.forFeature(localizationFeatureKey, featureReducer),
    EffectsModule.forFeature([FeatureEffects]),
  ],
})
export class LocalizationStoreModule {}
